


















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import AdminListView from '@/components/admin/AdminListView.vue';
import { ApplicationRecord } from '@/api';

@Component({
  components: {},
})
export default class extends Vue {
  item = 0;

  adminNavOpen: boolean = false;
  adminActionsOpen: boolean = false;

  items = [
    { text: 'Auctions', icon: 'mdi-gavel', to: { name: 'admin-auctions' } },
    {
      text: 'Users',
      icon: 'mdi-account-group',
      to: { name: 'admin-users' },
    },
    {
      text: 'Contact',
      icon: 'mdi-contact-mail',
      to: { name: 'admin-contact' },
    },
    {
      text: 'Terms',
      // Icons come from the MDI 4.9.95 CDN sheet in `public/index.html`, so
      // stick to long-standing names - the newer `-check` variants are not in it.
      icon: 'mdi-file-document',
      to: { name: 'admin-terms' },
    },
  ];

  get routeTitle() {
    return this.$route.meta.title;
  }

  listSelectChange(selected: ApplicationRecord[]) {
    // selection changed
  }

  @Watch('$route', { immediate: true })
  closeAction() {
    this.adminActionsOpen = false;
  }
}
